module.exports = __webpack_public_path__ + "img/logo.621712d9.svg";